import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../translation/anessa-translation.service';
import { UserpilotReloader } from '../../userpilot-reloader.component';

@Component({
  selector: 'app-confirmation-pop-up',
  templateUrl: './confirmation-pop-up.component.html',
  styleUrls: ['./confirmation-pop-up.component.scss']
})
export class ConfirmationPopUpComponent extends UserpilotReloader implements OnInit {
  @Input() confirmMessage = '';
  @Input() confirmText = '';
  @Input() rejectText = '';
  @Input() positionTop = null;
  @Input() positionBottom = null;
  @Input() positionLeft = null;
  @Input() positionRight = null;
  @Output() confirmed = new EventEmitter<any>();
  @Output() rejected = new EventEmitter<any>();

  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger?: string;

  constructor(public translationService: AnessaTranslationService) {
    super();
    this.confirmMessage = this.translationService.get('PROJECT.COMMON.SAVE_CONFIRM');
    this.confirmText = this.translationService.get('PROJECT.COMMON.YES');
    this.rejectText = this.translationService.get('PROJECT.COMMON.NO');
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  confirmClick() {
    this.confirmed.emit();
  }

  rejectClick() {
    this.rejected.emit();
  }
}
